module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_myreal.70239e85b08d10d96f4566a6345a2031.png";